<header class="fixed-top">
    <nav class="navbar navbar-expand-sm navbar-dark">
        <div class="container">
            <img src="assets/img/logo/logotipo_uoh-white.svg" alt="Logo Universidad de O'Higgins" class="img-fluid logo">

            <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#menu-home" aria-controls="menu-home" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="navbar-collapse collapse" id="menu-home">
                <ul class="navbar-nav mr-auto w-100 justify-content-end">
                    <li class="nav-item">
                        <a class="btn-cu btn-m btn-color-estandar" (click)="redirectClaveUnicaLogin()">
                            <span class="cl-claveunica"></span>
                            <span class="texto">Iniciar sesión</span>
                        </a>
                    </li>

                    <!-- <li class="nav-item ms-4">
                        <a class="nav-link link-light link-underline-opacity-0" href="#">Inicio</a>
                    </li> -->
                </ul>
            </div>
        </div>
    </nav>
</header>

<main>
    <section id="section-home-presentation" class="">
        <div class="container">
            <div class="d-block d-md-flex justify-content-center align-items-center px-5">
                <div class="text-light mb-4 mb-md-0" id="bienvenida">
                    <h2 class="">Bienvenidos al sistema de <span class="destacado-azul">Firma Electrónica</span> Simple</h2>
                    <p>Podrás firmar y revisar tus documentos</p>
                    <!-- <a href="#" target="_blank" class="link-light link-underline-opacity-0"><i class="fas fa-solid fa-circle-arrow-right fa-fw text-info"></i> Saber más</a> -->
                </div>

                <div class="">
                    <img class="img-fluid" id="img-portada" src="assets/img/firma-digital.png" alt="img-portada">
                </div>
            </div>
        </div>
    </section>

    <section id="section-home-services">
        <article class="services p-3">
            <div id="signature-container" class="mb-3">
                <i class="fas fa-solid fa-signature fa-fw fa-lg text-primary"></i>
            </div>
            <strong class="text-dark">Tramitar Firma</strong>
            <p>Permite firmar documentos electrónicos.</p>
            <a class="btn-cu btn-m btn-color-estandar" (click)="redirectClaveUnicaLogin()">
                <span class="cl-claveunica"></span>
                <span class="texto">Iniciar sesión</span>
            </a>
        </article>
        <div *ngIf="mainLoad" class="overlay">
            <i class="fa fa-circle-notch fa-spin"></i>
        </div>
    </section>
</main>

<app-footer></app-footer>
